<template>
    <el-dialog class="add_purchase_order" :visible.sync="dialogVisible" :append-to-body="true" :title="dialogTitle"
        width="1280px" @close="handleClose" :modal-append-to-body="true">
        <div class="purchase-order">

            <!-- 基础信息部分 - 编辑模式下显示为文本 -->

            <div v-if="isEdit" class="base-info-readonly">
                <div class="order-form">
                    基础信息
                </div>
                <el-row v-if="baseInfo.processInstanceId" :gutter="20" class="info-row" style="margin-left: 32px;">
                    <el-col :span="6">
                        <div class="info-item">
                            <label>采购申请单号：</label>
                            <span class="application-no-text">{{ baseInfo.applicationNo || '无' }}</span>
                            <el-button type="primary" plain @click="showApprovalDetail" size="mini">查看</el-button>
                        </div>
                    </el-col>

                    <el-col :span="6">
                        <div class="info-item">
                            <label>采购申请人：</label>
                            <span>{{ baseInfo.applicantName || '无' }}</span>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="info-item">
                            <label>采购申请人所属部门：</label>
                            <span>{{ baseInfo.applicantDepartmentName || '无' }}</span>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20" class="info-row" style="margin-left: 32px;">
                    <el-col :span="6">
                        <div class="info-item">
                            <label>采购单号：</label>
                            <span>{{ baseInfo.purchaseOrderNo || '无' }}</span>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="info-item">
                            <label>采购单状态：</label>
                            <span>{{ baseInfo.statusLabel || '无' }}</span>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="info-item">
                            <label>创建人：</label>
                            <span>{{ baseInfo.createdByName || '无' }}</span>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="info-item" v-if="baseInfo.purchaseType === 1">
                            <label>紧急采购：</label>
                            <span>{{ urgentFlag || '-' }}</span>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20" class="info-row" style="margin-left: 32px;">
                    <el-col :span="6">
                        <div class="info-item">
                            <label>{{ baseInfo.purchaseType === 1 ? ' 申请采购时间：' : '创建时间：' }}</label>
                            <span>{{ baseInfo.purchaseType === 1 ? baseInfo.applicationTime : baseInfo.createdTime
                                }}</span>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="info-item" v-if="baseInfo.purchaseType === 1">
                            <label>申请通过/采购单位时间：</label>
                            <span>{{ baseInfo.createdTime || '无' }}</span>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="info-item">
                            <label>修改时间：</label>
                            <span>{{ baseInfo.updatedTime || '无' }}</span>
                        </div>
                    </el-col>
                </el-row>
            </div>

            <el-form :model="form" :rules="rules" ref="orderForm" label-width="110px" label-position="right">

                <template v-if="baseInfo.purchaseType === 2 || type === 'add'">
                    <div class="order-form">
                        供应商信息
                    </div>
                    <el-row :gutter="20">
                        <el-col :span="6">
                            <el-form-item label="供应商" prop="supplierId">
                                <el-select v-model="form.supplierId" placeholder="请选择" clearable filterable
                                    popper-class="supplier-select" :disabled="isEffective">
                                    <el-option v-for="(item, index) in supplierOptions"
                                        :key="(item && item.id) || index" :label="(item && item.name) || '未知供应商'"
                                        :value="item && item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="销货清单编号" prop="salesInvoiceNo">
                                <el-input v-model="form.salesInvoiceNo" maxlength="12" clearable placeholder="请输入"
                                    :disabled="isEffective"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="业务员" prop="supplierContactPerson">
                                <el-input v-model="form.supplierContactPerson" maxlength="30" clearable
                                    placeholder="请输入" :disabled="isEffective"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="业务员联系号码" prop="supplierContactNumber">
                                <el-input v-model="form.supplierContactNumber" @input="handleInput" maxlength="20"
                                    clearable placeholder="请输入" :disabled="isEffective"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="发货地址" prop="supplierShippingAddress">
                                <el-input v-model="form.supplierShippingAddress" maxlength="100" clearable
                                    placeholder="请输入" :disabled="isEffective"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="店铺名称" prop="storeName">
                                <el-input v-model="form.storeName" maxlength="32" clearable placeholder="请输入"
                                    :disabled="isEffective"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </template>


                <!-- 采购商品列表(销售商品) -->
                <template v-if="baseInfo.purchaseType === 2 || type === 'add'">
                    <div class="order-form">
                        商品信息
                        <el-button v-if="!isEdit && !isEffective" type="text" size="mini"
                            @click="showGoodsSelector">添加商品</el-button>
                    </div>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item>
                                <el-table class="goods-table" :data="form.items" border :rules="tableRules.items"
                                    style="width: 100%; margin-top: 10px;margin-left: -70px;"
                                    :summary-method="getSummaries" show-summary>
                                    <el-table-column type="index" label="序号" width="60"
                                        align="center"></el-table-column>
                                    <el-table-column label="商品名称" min-width="150" class-name="goods-name-cell">
                                        <template slot="header">
                                            <span class="required-label">商品名称</span>
                                        </template>
                                        <template slot-scope="scope">
                                            <!-- 修改：商品名称不可编辑，只能通过添加商品获取 -->
                                            <span class="goods-name-text">{{ scope.row.goodsName || '-' }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="商品图片" min-width="100">
                                        <template slot-scope="scope">
                                            <img v-if="scope.row.productImageUrl" :src="scope.row.productImageUrl"
                                                width="50" height="50" style="object-fit: cover;" />
                                            <span v-else>-</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="商品编码" prop="goodsNo" width="120"></el-table-column>
                                    <el-table-column prop="quantity" label="采购数量" min-width="120">
                                        <template slot="header">
                                            <span class="required-label">采购数量</span>
                                        </template>
                                        <template slot-scope="scope">
                                            <el-form-item :prop="'items.' + scope.$index + '.quantity'"
                                                :rules="tableRules.quantity" style="margin-bottom: 0;">
                                                <el-input v-if="!isEdit && !isEffective"
                                                    v-model.number="scope.row.quantity" placeholder="请输入"
                                                    @input="calculateAmount(scope.$index)"
                                                    @blur="validateTableField(scope.$index, 'quantity')"
                                                    maxlength="16"></el-input>
                                                <span v-else>{{ scope.row.quantity || 0 }}</span>
                                            </el-form-item>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="unitPrice" label="采购单价" min-width="120">
                                        <template slot="header">
                                            <span class="required-label">采购单价</span>
                                        </template>
                                        <template slot-scope="scope">
                                            <!-- 只在销售商品类型下显示表单验证 -->
                                            <el-form-item v-if="baseInfo.purchaseType === 2 || type === 'add'"
                                                :prop="'items.' + scope.$index + '.unitPrice'"
                                                :rules="tableRules.unitPrice" style="margin-bottom: 0;">
                                                <el-input v-if="!isEdit && !isEffective"
                                                    v-model.number="scope.row.unitPrice" placeholder="请输入"
                                                    @input="handleUnitPriceInput(scope.$index, $event)"
                                                    @blur="validateTableField(scope.$index, 'unitPrice')"
                                                    maxlength="16"></el-input>
                                                <span v-else>{{ formatCurrency(scope.row.unitPrice) }}</span>
                                            </el-form-item>
                                            <!-- 办公物资类型下不显示表单验证 -->
                                            <div v-else>
                                                <el-input v-if="!isEdit && !isEffective"
                                                    v-model.number="scope.row.unitPrice" placeholder="请输入"
                                                    @input="handleUnitPriceInput(scope.$index, $event)"
                                                    maxlength="16"></el-input>
                                                <span v-else>{{ formatCurrency(scope.row.unitPrice) }}</span>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="lineAmount" label="金额(元)" min-width="120">
                                        <template slot="header">
                                            <span class="required-label">金额(元)</span>
                                        </template>
                                        <template slot-scope="scope">
                                            <el-input :value="formatCurrency(scope.row.lineAmount)"
                                                :disabled="true"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="商品备注" min-width="150">
                                        <template slot-scope="scope">
                                            <el-input v-if="!isEdit && !isEffective" v-model="scope.row.remarks"
                                                placeholder="请输入"></el-input>
                                            <span v-else>{{ scope.row.remarks || '-' }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="库存单位" prop="unitOfMeasure" width="80"></el-table-column>
                                    <el-table-column label="品牌" width="80">
                                        <template slot-scope="scope">
                                            {{ scope.row.brandName || '-' }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="可用库存" prop="stock" width="80"></el-table-column>
                                    <el-table-column v-if="!isEdit && !isEffective" label="操作" width="80">
                                        <template slot-scope="scope">
                                            <el-button type="text" size="mini"
                                                @click="removeItem(scope.$index)">删除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </template>
                <!-- 采购商品列表(办公物资) -->
                <template v-if="baseInfo.purchaseType === 1 || (type === 'add' && formData.purchaseType === 1)">
                    <div class="order-form">
                        商品信息
                        <el-button v-if="!isEdit && !isEffective" type="text" size="mini"
                            @click="showGoodsSelector">添加商品</el-button>
                    </div>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item>
                                <el-table :data="form.items" border
                                    style="width: 100%; margin-top: 10px;margin-left: -70px;"
                                    :summary-method="getSummaries" show-summary>
                                    <!-- 表格列内容保持不变 -->
                                    <el-table-column type="index" label="序号" width="60"
                                        align="center"></el-table-column>
                                    <el-table-column label="物品名称" min-width="100" class-name="goods-name-cell">
                                        <template slot-scope="scope">
                                            <span class="goods-name-text">{{ scope.row.goodsName || '-' }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="规格" min-width="100">
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.specification || '-' }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="单位" prop="unitOfMeasure" width="120"></el-table-column>
                                    <el-table-column prop="quantity" label="采购数量" min-width="100">
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.quantity || 0 }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="estimatedUnitPrice" label="估价" min-width="100">
                                        <template slot-scope="scope">
                                            <span>{{ formatCurrency(scope.row.estimatedUnitPrice) || 0.00 }}</span>
                                        </template>
                                    </el-table-column>
                                    <!-- 修改实际采购金额列 -->
                                    <el-table-column prop="lineAmount" label="实际采购金额(元)" min-width="150">
                                        <template slot-scope="scope">
                                            <el-input v-if="!isEffective" v-model="scope.row.lineAmount"
                                                placeholder="请输入" @input="handleLineAmountInput(scope.$index, $event)"
                                                :disabled="isEffective"></el-input>
                                            <el-input v-else :value="formatCurrency(scope.row.lineAmount)"
                                                :disabled="true"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="需求到货时间" min-width="180">
                                        <template slot-scope="scope">
                                            <span>{{ formatDateTime(scope.row.requiredDeliveryTime) || '-'
                                                }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="供应商" prop="supplierId" width="120">
                                        <template slot-scope="scope">
                                            <el-select v-if="!isEffective" v-model="scope.row.supplierId"
                                                placeholder="请选择" clearable filterable popper-class="supplier-select"
                                                @change="handleSupplierChange(scope.$index, $event)"
                                                :disabled="isEffective">
                                                <el-option v-for="(item, index) in supplierOptions"
                                                    :key="(item && item.id) || index"
                                                    :label="(item && item.name) || '未知供应商'"
                                                    :value="(item && item.id) || ''">
                                                </el-option>
                                            </el-select>
                                            <span v-else>{{ scope.row.supplierName || '-' }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="图片特殊备注" width="120">
                                        <template slot-scope="scope">
                                            {{ scope.row.imageSpecialNotes || '-' }}
                                        </template>
                                    </el-table-column>
                                    <!-- <el-table-column v-if="!isEffective" label="操作" width="80">
                                        <template slot-scope="scope">
                                            <el-button type="text" size="mini"
                                                @click="removeItem(scope.$index)">删除</el-button>
                                        </template>
                                    </el-table-column> -->
                                </el-table>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </template>

                <div class="order-form">
                    采购信息
                </div>
                <el-row :gutter="20">
                    <el-col :span="6">
                        <el-form-item label="采购员" prop="purchaserId">
                            <el-select ref="purchaserSelect" v-model="form.purchaserId" placeholder="请选择" clearable
                                @focus="openUserPicker" @visible-change="handlePurchaserSelectVisible"
                                popper-class="supplier-select" :disabled="isEffective">
                                <el-option v-if="form.purchaserId && form.purchaserName" :key="form.purchaserId"
                                    :label="form.purchaserName" :value="form.purchaserId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="运费" prop="freightCost">
                            <el-input v-model="form.freightCost" maxlength="16" placeholder="请输入"
                                @input="handleFreightCostInput" :disabled="isEffective"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="优惠金额" prop="discountAmount">
                            <el-input v-model="form.discountAmount" placeholder="自动计算" :disabled="true"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="采购总金额" prop="finalAmount">
                            <el-input v-model="form.finalAmount" maxlength="16" placeholder="请输入"
                                @input="handleFinalAmountInput" :disabled="isEffective"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="收货地址" prop="shippingAddress">
                            <el-input v-model="form.shippingAddress" maxlength="64" placeholder="请输入"
                                :disabled="isEffective"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="采购单备注" prop="remarks">
                            <el-input v-model="form.remarks" maxlength="64" placeholder="请输入"
                                :disabled="isEffective"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="6">
                        <el-form-item label="附件" prop="attachmentUrl">
                            <!-- 上传按钮只在没有附件时显示 -->
                            <el-upload v-if="fileList.length === 0" ref="upload" accept="*" drag action="#"
                                :multiple="false" :http-request="orderImportLive" :limit="1"
                                :before-upload="beforeUpload" :file-list="fileList">
                                <el-button type="primary" plain size="mini">点击上传</el-button>
                            </el-upload>
                            <!-- 文件列表显示 -->
                            <div v-else class="file-list">
                                <div class="file-item">
                                    <i class="el-icon-document"></i>
                                    <span class="file-name">{{ (fileList[0] && fileList[0].name) || '附件' }}</span>
                                    <el-button v-if="!isEffective" type="text" size="mini"
                                        @click="handleRemove">删除</el-button>
                                </div>
                            </div> <!-- 文件上传说明 -->
                            <div class="upload-tips">
                                (大小限制在4M以内，格式不限)
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
            <!-- 只在非生效状态下显示确认生效和保存按钮 -->
            <el-button v-if="(type === 'add' || (isEdit && baseInfo.status === 0)) && !isEffective" size="mini"
                type="primary" @click="confirmEffect">
                确认生效
            </el-button>
            <el-button v-if="!isEffective" size="mini" @click="saveForm">保存</el-button>
            <el-button size="mini" @click="dialogVisible = false">取消</el-button>
        </div>
        <org-picker title="选择采购员" :multiple="false" ref="orgPicker" @ok="selectedPurchaser" />
        <GoodsSelector ref="goodsSelector" @selected="addSelectedGoods" />
        <pop-process ref="popProcess" />
    </el-dialog>
</template>

<script>
import OrgPicker from "@/components/OrgPicker.vue";
import GoodsSelector from "../components/common/Goodselector.vue";
import PopProcess from "@/pages/purchase/components/common/popProcess";
export default {
    name: 'PurchaseOrderDialog',
    components: {
        OrgPicker, GoodsSelector, PopProcess
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'add'
        },
        formData: {
            type: Object,
            default: () => ({})
        },
        goodsOptions: {
            type: Array,
            default: () => []
        }
    },
    filters: {
        currency(value) {
            if (!value) return '¥0.00';
            return '¥' + Number(value).toFixed(2);
        },
    },
    data() {
        // 供应商校验
        const validateSupplier = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请选择供应商'));
            } else {
                callback();
            }
        };

        // 采购员校验
        const validatePurchaserId = (rule, value, callback) => {
            if (this.shouldValidatePurchaseInfo === true) {
                if (!value) {
                    callback(new Error('请选择采购员'));
                } else {
                    callback();
                }
            } else {
                callback();
            }

        };

        // 采购总金额校验
        const validateFinalAmount = (rule, value, callback) => {
            // 只有在需要校验采购信息是才进行校验
            if (this.shouldValidatePurchaseInfo) {
                if (!value || parseFloat(value) <= 0) {
                    callback(new Error('采购总金额必须大于0'));
                } else {
                    callback();
                }
            } else {
                callback();
            }

        };

        // 表格商品数量校验
        const validateTableQuantity = (rule, value, callback, source) => {
            const index = rule.field.split('.')[1]; // 获取表格行索引
            const item = this.form.items[index];
            if (!item.quantity || parseFloat(item.quantity) <= 0) {
                callback(new Error('采购数量必须大于0'));
            } else {
                callback();
            }
        };

        // 表格商品单价校验
        const validateTableUnitPrice = (rule, value, callback, source) => {
            const index = rule.field.split('.')[1]; // 获取表格行索引
            const item = this.form.items[index];
            if (!item.unitPrice || parseFloat(item.unitPrice) < 0) {
                callback(new Error('采购单价不能为负数'));
            } else {
                callback();
            }
        };
        return {
            rules: {
                supplierId: [{ required: true, validator: validateSupplier, trigger: 'change' }],
                purchaserId: [{ required: true, validator: validatePurchaserId, trigger: 'change' }],
                finalAmount: [{ required: true, validator: validateFinalAmount, trigger: 'change' }],
                // 动态表格校验规则
                items: {
                    type: 'array',
                    required: true,
                    min: 1,
                    message: '请至少添加一个商品',
                    trigger: 'change'
                }
            },
            // 添加表格列校验规则
            tableRules: {
                quantity: [
                    { required: true, message: '请填写采购数量', trigger: 'blur' }
                ],
                unitPrice: [
                    {
                        required: true,
                        message: '请填写采购单价',
                        trigger: 'blur',
                        validator: (rule, value, callback) => {
                            // 只在销售商品类型下校验采购单价
                            if (this.baseInfo.purchaseType === 2 || this.type === 'add') {
                                if (!value && value !== 0) {
                                    callback(new Error('请填写采购单价'));
                                } else if (parseFloat(value) < 0) {
                                    callback(new Error('采购单价不能为负数'));
                                } else {
                                    callback();
                                }
                            } else {
                                callback();
                            }
                        }
                    }
                ],
                estimatedUnitPrice: [
                    {
                        required: false, // 估价不是必填项
                        trigger: 'blur',
                        validator: (rule, value, callback) => {
                            // 只在办公物资类型下校验估价
                            if (this.baseInfo.purchaseType === 1) {
                                if (value && parseFloat(value) < 0) {
                                    callback(new Error('估价不能为负数'));
                                } else {
                                    callback();
                                }
                            } else {
                                callback();
                            }
                        }
                    }
                ]
            },
            supplierOptions: [],
            baseInfo: {
                purchaseApplyNo: '',
                purchaseApplicant: '',
                applicantDepartmentName: '',
                purchaseUnit: '',
                purchaseUnitName: '',
                applyTime: '',
                processInstanceId: null,
            },
            form: {
                id: null,
                supplierId: null,
                salesInvoiceNo: '',
                supplierContactPerson: '',
                supplierContactNumber: '',
                supplierShippingAddress: '',
                storeName: '',
                purchaserId: '',
                purchaserName: '',
                freightCost: 0,
                discountAmount: 0,
                finalAmount: 0,
                shippingAddress: '',
                remarks: '',
                attachmentUrl: '',
                items: [],
                purchaseType: null
            },
            fileList: [], // 添加文件列表
            logFile: null // 添加文件上传数据
        };
    },
    created() {
        this.getSupplierList();
    },
    computed: {
        dialogVisible: {
            get() {

                return this.visible;
            },
            set(value) {
                this.resetFormData();
                this.$emit('update:visible', value);
            }
        },
        dialogTitle() {
            if (this.type === 'add') {
                return '新增销售商品采购单';
            } else {
                if (this.baseInfo.purchaseType === 1) {
                    return '查看/编辑办公物资采购单';
                } else if (this.baseInfo.purchaseType === 2) {
                    return '查看/编辑销售商品采购单';
                } else {
                    return '查看/编辑采购单'; // 默认标题
                }
            }
        },
        isEdit() {
            return this.type === 'edit';
        },
        urgentFlag() {
            return this.baseInfo.urgentFlag === true ? '是' : '否'
        },
        totalAmount() {
            return this.form.items.reduce((total, item) => {
                return total + (parseFloat(item.lineAmount) || 0);
            }, 0);
        },
        isEffective() {
            // 编辑模式且状态为1（已生效）、2（已作废），或者查看模式
            if (this.isEdit) {
                return this.baseInfo.status === 1 || this.baseInfo.status === 2; // 状态1为已生效
            }
            return false; // 新增模式下不是已生效状态
        },
        shouldValidatePurchaseInfo() {
            // 只有在非生效状态且非作废状态下才需要校验采购信息
            if (this.isEdit) {
                return this.baseInfo.status === 0; // 状态1为已生效
            }
            return true; // 新增模式下需要校验
        }

    },
    watch: {
        dialogVisible: {
            immediate: true,
            handler(newVal) {
                if (newVal && this.isEdit && this.formData.id) {
                    // 对话框打开且是编辑模式时，调用详情接口
                    this.getOrderDetail(this.formData.id);
                } else if (newVal && this.type === 'add') {
                    // 新增状态下重置表单数据
                    this.resetFormData();
                }
            }
        },
        formData: {
            immediate: true,
            deep: true,
            handler(newVal) {
                if (newVal && Object.keys(newVal).length > 0) {
                    // 只有当不是编辑模式或者编辑模式但没有调用详情接口时才使用传入的数据
                    if (!this.isEdit || !newVal.id) {
                        Object.keys(this.form).forEach(key => {
                            if (newVal[key] !== undefined && newVal[key] !== null) {
                                if (Array.isArray(newVal[key])) {
                                    this.form[key] = JSON.parse(JSON.stringify(newVal[key]));
                                } else if (typeof newVal[key] === 'object') {
                                    this.form[key] = { ...newVal[key] };
                                } else {
                                    this.form[key] = newVal[key];
                                }
                            }
                        });

                        if (!this.form.items) {
                            this.form.items = [];
                        }

                        // 初始化时计算优惠金额
                        this.calculateDiscountAmount();

                        // 设置基础信息（编辑模式下显示）
                        if (this.isEdit) {
                            this.setBaseInfo(newVal);
                        }
                    }
                } else if (this.type === 'add') {
                    // 新增状态且没有传入数据时，重置表单

                    this.form = {
                        ...this.form,
                        id: null,
                        supplierId: null,
                        salesInvoiceNo: '',
                        supplierContactPerson: '',
                        supplierContactNumber: '',
                        supplierShippingAddress: '',
                        storeName: '',
                        purchaserId: '',
                        purchaserName: '',
                        freightCost: 0,
                        discountAmount: 0,
                        finalAmount: 0,
                        shippingAddress: '',
                        remarks: '',
                        attachmentUrl: '',
                        items: [],
                        purchaseType: null
                    };

                    // 清空基础信息
                    this.baseInfo = {
                        purchaseApplyNo: '',
                        purchaseApplicant: '',
                        applicantDepartmentName: '',
                        purchaseUnit: '',
                        purchaseUnitName: '',
                        applyTime: '',
                        processInstanceId: null,
                    };

                    // 清空文件列表
                    this.fileList = [];
                    this.logFile = null;
                }
            }
        },
        // 监听运费变化，重新计算优惠金额
        'form.freightCost': {
            handler(newVal) {
                this.calculateDiscountAmount();
            },
            deep: true
        },
        // 监听采购总金额变化，重新计算优惠金额
        'form.finalAmount': {
            handler(newVal) {
                this.calculateDiscountAmount();
            },
            deep: true
        },
        // 监听商品总金额变化，重新计算优惠金额
        totalAmount(newVal) {
            this.calculateDiscountAmount();
        }
    },
    methods: {
        // 处理供应商选择变化
        handleSupplierChange(index, value) {
            const selectedSupplier = (this.supplierOptions || []).filter(Boolean).find(item => item.name === value);
            console.log('handleSupplierChange11', index, value, selectedSupplier);

            if (selectedSupplier) {
                // 如果需要，可以在这里保存供应商ID或其他信息
                this.$set(this.form.items[index], 'supplierId', selectedSupplier.id);
            }
        },

        // 阻止采购员下拉框展开
        handlePurchaserSelectVisible(visible) {
            if (visible && this.$refs.purchaserSelect) {
                this.$nextTick(() => {
                    // 关闭下拉并移除焦点，避免显示历史选项
                    if (this.$refs.purchaserSelect.blur) {
                        this.$refs.purchaserSelect.blur();
                    }
                    this.$refs.purchaserSelect.visible = false;
                });
            }
        },

        // 获取供应商列表（使用分页接口）
        async getSupplierList() {
            try {
                const params = {
                    pageNum: 1,
                    pageSize: 1000 // 获取足够多的数据，避免分页
                };
                const response = await this.$api.srmSupplierList(params);
                console.log('getSupplierList response:', response);

                if (response.code === 0) {
                    const rawList = Array.isArray(response.data) ? response.data : [];
                    // 过滤掉空项并保证字段存在
                    this.supplierOptions = rawList.filter(item => item && (item.id !== undefined || item.name !== undefined));
                } else {
                    console.error('获取供应商列表失败:', response.msg);
                    this.supplierOptions = [];
                }
            } catch (error) {
                console.error('获取供应商列表异常:', error);
                this.supplierOptions = [];
            }
        },

        // 计算优惠金额
        calculateDiscountAmount() {
            const totalAmount = this.totalAmount;
            const finalAmount = parseFloat(this.form.finalAmount) || 0;
            const freightCost = parseFloat(this.form.freightCost) || 0;
            console.log('calculateDiscountAmount', totalAmount, finalAmount, freightCost);

            const discountAmount = freightCost + totalAmount - finalAmount;
            // 移除这里的提示逻辑，只在提交时判断
            this.form.discountAmount = isNaN(discountAmount) ? 0 : discountAmount.toFixed(2);
            console.log('discountAmount', this.form.discountAmount, discountAmount);

        },

        // 处理采购总金额输入
        handleFinalAmountInput(value) {
            // 只允许数字和小数点
            let formattedValue = value.replace(/[^\d.]/g, '');

            // 限制只能有一个小数点
            const parts = formattedValue.split('.');
            if (parts.length > 2) {
                formattedValue = parts[0] + '.' + parts.slice(1).join('');
            }

            // 限制小数点后最多两位
            if (parts.length === 2 && parts[1].length > 2) {
                formattedValue = parts[0] + '.' + parts[1].substring(0, 2);
            }

            this.form.finalAmount = formattedValue;
        },

        handleLineAmountInput(index, value) {
            // 只允许数字和小数点
            let formattedValue = value.replace(/[^\d.]/g, '');

            // 限制只能有一个小数点
            const parts = formattedValue.split('.');
            if (parts.length > 2) {
                formattedValue = parts[0] + '.' + parts.slice(1).join('');
            }

            // 限制小数点后最多两位
            if (parts.length === 2 && parts[1].length > 2) {
                formattedValue = parts[0] + '.' + parts[1].substring(0, 2);
            }

            // 更新值
            this.form.items[index].lineAmount = formattedValue;

            // 重新计算优惠金额
            this.calculateDiscountAmount();
        },
        // 重置表单数据
        resetFormData() {
            this.form = {
                id: null,
                supplierId: null,
                salesInvoiceNo: '',
                supplierContactPerson: '',
                supplierContactNumber: '',
                supplierShippingAddress: '',
                storeName: '',
                purchaserId: '',
                purchaserName: '',
                freightCost: 0,
                discountAmount: 0,
                finalAmount: 0,
                shippingAddress: '',
                remarks: '',
                attachmentUrl: '',
                items: [],
                purchaseType: null,
                attachmentList: [],
            };

            // 重置文件列表
            this.fileList = [];
            this.logFile = null;

            // 重置基础信息
            this.baseInfo = {
                purchaseApplyNo: '',
                purchaseApplicant: '',
                applicantDepartmentName: '',
                purchaseUnit: '',
                purchaseUnitName: '',
                applyTime: '',
                processInstanceId: null,
            };

            // 清除表单验证
            if (this.$refs.orderForm) {
                this.$refs.orderForm.clearValidate();
            }
        },
        // 处理单价输入
        handleUnitPriceInput(index, value) {
            // 只允许数字和小数点
            let formattedValue = value.replace(/[^\d.]/g, '');

            // 限制只能有一个小数点
            const parts = formattedValue.split('.');
            if (parts.length > 2) {
                formattedValue = parts[0] + '.' + parts.slice(1).join('');
            }

            // 限制小数点后最多两位
            if (parts.length === 2 && parts[1].length > 2) {
                formattedValue = parts[0] + '.' + parts[1].substring(0, 2);
            }

            // 更新值
            this.form.items[index].unitPrice = formattedValue;
            this.calculateAmount(index);
        },


        // 处理运费输入
        handleFreightCostInput(value) {
            // 只允许数字和小数点
            let formattedValue = value.replace(/[^\d.]/g, '');

            // 限制只能有一个小数点
            const parts = formattedValue.split('.');
            if (parts.length > 2) {
                formattedValue = parts[0] + '.' + parts.slice(1).join('');
            }

            // 限制小数点后最多两位
            if (parts.length === 2 && parts[1].length > 2) {
                formattedValue = parts[0] + '.' + parts[1].substring(0, 2);
            }

            this.form.freightCost = formattedValue;
        },

        handleInput(value) {
            // 使用正则表达式确保只输入整数
            this.form.supplierContactNumber = value.replace(/[^\d]/g, '');
        },

        // 校验表格字段
        validateTableField(index, field) {
            const item = this.form.items[index];
            let isValid = true;
            let message = '';

            // 根据采购类型决定校验规则
            const isOfficeSupply = this.baseInfo.purchaseType === 1;
            const isSalesProduct = this.baseInfo.purchaseType === 2 || this.type === 'add';

            switch (field) {
                case 'quantity':
                    if (!item.quantity || parseFloat(item.quantity) <= 0) {
                        isValid = false;
                        message = '采购数量必须大于0';
                    }
                    break;
                case 'unitPrice':
                    // 只在销售商品类型下校验采购单价
                    if (isSalesProduct) {
                        if (!item.unitPrice || parseFloat(item.unitPrice) < 0) {
                            isValid = false;
                            message = '采购单价不能为负数';
                        }
                    }
                    break;
                case 'estimatedUnitPrice':
                    // 只在办公物资类型下校验估价
                    if (isOfficeSupply) {
                        if (!item.estimatedUnitPrice || parseFloat(item.estimatedUnitPrice) < 0) {
                            isValid = false;
                            message = '估价不能为负数';
                        }
                    }
                    break;
            }

            if (!isValid) {
                this.$message.error(message);
                // 可以在这里设置错误状态
                this.$set(item, '_error', true);
            } else {
                this.$set(item, '_error', false);
            }

            return isValid;
        },
        formatDateTime(value) {
            if (!value) return '';
            try {
                // 处理 ISO 格式日期（如：2025-10-29T00:00:00.000+0800）
                const date = new Date(value);

                // 检查日期是否有效
                if (isNaN(date.getTime())) {
                    return value; // 如果解析失败，返回原值
                }

                // 格式化为 "YYYY-MM-DD HH:mm:ss"
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');

                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            } catch (error) {
                console.error('日期格式化错误:', error, value);
                return value; // 如果解析失败，返回原值
            }
        },
        // 确认生效按钮
        confirmEffect() {
            if (this.baseInfo.purchaseType === 2 || this.type === 'add') {
                if (!this.form.salesInvoiceNo || this.form.salesInvoiceNo.trim() === '') {
                    this.$message.error('若确认生效，销货订单号必填')
                    return;
                }
            }
            this.submitForm(true);
        },

        // 保存按钮
        saveForm() {
            this.submitForm(false);
        },

        // 调用查看审批详情组件
        // 显示审批详情
        showApprovalDetail() {
            if (!this.baseInfo.processInstanceId) {
                this.$message.warning('该公告没有审批流程信息');
                return;
            }
            console.log('传递的 processInstanceId:', this.baseInfo.processInstanceId) // 调试信息
            // this.approvalBtnLoading = true;

            // 调用审批详情组件
            this.$refs.popProcess.show(this.baseInfo.processInstanceId);

            // 模拟加载，实际使用时可以根据需要调整
            // setTimeout(() => {
            //     this.approvalBtnLoading = false;
            // }, 500);
        },
        // 获取订单详情
        async getOrderDetail(id) {
            try {
                const response = await this.$api.srmSurchaseOrderDetail({ id: id });
                if (response.code === 0) {
                    const detailData = response.data;
                    console.log('getOrderDetail response:', detailData);

                    // 将详情数据填充到表单中
                    this.fillFormData(detailData);
                    // 设置基础信息
                    this.setBaseInfo(detailData);
                } else {
                    this.$message.error(response.msg || '获取订单详情失败');
                }
            } catch (error) {
                console.error('获取订单详情失败:', error);
                this.$message.error('获取订单详情失败，请稍后重试');
            }
        },

        // 填充表单数据
        fillFormData(data) {
            // 填充基本表单数据
            Object.keys(this.form).forEach(key => {
                if (data[key] !== undefined && data[key] !== null) {
                    if (Array.isArray(data[key])) {
                        this.form[key] = JSON.parse(JSON.stringify(data[key]));
                    } else if (typeof data[key] === 'object') {
                        this.form[key] = { ...data[key] };
                    } else {
                        this.form[key] = data[key];
                    }
                }
            });

            // 确保items存在
            if (!this.form.items) {
                this.form.items = [];
            }

            // 特殊处理：办公物资类型的数据字段适配
            if (data.purchaseType === 1) {
                this.form.items = this.form.items.map(item => {
                    // 确保办公物资类型的必要字段存在
                    return {
                        ...item,
                        specification: item.specification || '', // 规格
                        estimatedAmount: item.estimatedUnitPrice || 0, // 估价
                        lineAmount: item.lineAmount || 0, // 实际采购金额
                        requiredDeliveryTime: item.requiredDeliveryTime || '', // 需求到货时间
                        supplierName: item.supplierName || '', // 供应商名称
                        imageSpecialNotes: item.imageSpecialNotes || '', // 图片特殊备注
                        // 确保商品相关字段存在
                        goodsName: item.goodsName || item.name || '',
                        goodsId: item.goodsId || item.id,
                        goodsNo: item.goodsNo || item.productNo || '',
                        unitOfMeasure: item.unitOfMeasure || item.unit || '',
                        quantity: item.quantity || 0
                    };
                });
            }

            // 计算优惠金额
            this.calculateDiscountAmount();

            // 设置文件列表
            if (this.form.attachmentUrl) {
                this.fileList = [{
                    name: this.form.attachmentName || '附件',
                    url: this.form.attachmentUrl
                }];
            }
        },

        // 文件上传相关方法
        orderImportLive(fileObj) {
            const formData = new FormData();
            formData.append('file', fileObj.file);
            this.logFile = formData;

            this.uploadFile().then(() => {
                this.$message.success('文件上传成功！');
            }).catch(error => {
                this.$message.error('文件上传失败！');
                console.error('文件上传失败:', error);
            });
        },

        async uploadFile() {
            if (!this.logFile) {
                this.$message.warning('请选择文件');
                return Promise.reject('没有选择文件');
            }

            try {
                const config = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    timeout: 120000
                };

                const response = await this.$api.uploadFiles(this.logFile, config);

                if (response.code === 0) {
                    this.form.attachmentUrl = response.data.fileUrl || response.data.url;
                    this.form.attachmentName = response.data.fileName || this.getFileNameFromFormData();

                    // 更新文件列表显示
                    this.fileList = [{
                        name: this.form.attachmentName,
                        url: this.form.attachmentUrl
                    }];

                    return Promise.resolve();
                } else {
                    this.$message.error(response.msg || '文件上传失败');
                    return Promise.reject(response.msg);
                }
            } catch (error) {
                this.$message.error('文件上传失败，请稍后重试');
                console.error('文件上传失败:', error);
                return Promise.reject(error);
            }
        },

        getFileNameFromFormData() {
            if (this.logFile && this.logFile.get('file')) {
                return this.logFile.get('file').name;
            }
            return '附件';
        },

        handleRemove(file, fileList) {
            this.logFile = null;
            this.form.attachmentUrl = '';
            this.form.attachmentName = '';
            this.fileList = [];
            this.$message.info('文件已移除');
        },

        beforeUpload(file) {
            // 修改为4M大小限制
            const isLt4M = file.size / 1024 / 1024 < 4;

            // 移除文件类型限制
            if (!isLt4M) {
                this.$message.error('文件大小不能超过 4MB!');
                return false;
            }

            return true;
        },

        // 设置基础信息
        setBaseInfo(data) {
            this.baseInfo = data;
            console.log('设置基础信息:', this.baseInfo);

        },

        // 格式化金额显示
        formatCurrency(value) {
            if (value === null || value === undefined || value === '') return '¥0.00';
            const numValue = parseFloat(value);
            if (isNaN(numValue)) return '¥0.00';
            return '¥' + numValue.toFixed(2);
        },

        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }

                if (column.property === 'quantity' || column.property === 'lineAmount') {
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        if (column.property === 'lineAmount') {
                            sums[index] = '¥' + sums[index].toFixed(2);
                        } else if (column.property === 'quantity') {
                            sums[index] = Math.round(sums[index]);
                        }
                    } else {
                        sums[index] = 'N/A';
                    }
                } else {
                    sums[index] = '';
                }
            });

            return sums;
        },

        showGoodsSelector() {
            this.$refs.goodsSelector.show();
        },

        addSelectedGoods(selectedGoods) {
            selectedGoods.forEach(good => {
                const existingIndex = this.form.items.findIndex(item => item.goodsId === good.id);
                if (existingIndex === -1) {
                    const newItem = {
                        goodsId: good.id,
                        goodsName: good.name,
                        goodsNo: good.goodsNo,
                        productImageUrl: good.mainImage || good.productImageUrl || '',
                        brandName: good.brand || good.brandName || '-',
                        unitOfMeasure: good.unitOfMeasure || good.unit || '-',
                        quantity: 1,
                        unitPrice: 0,
                        lineAmount: 0,
                        remarks: ''
                    };
                    this.form.items.push(newItem);
                } else {
                    this.$message.warning(`商品 "${good.name}" 已存在`);
                }
            });
        },

        openUserPicker() {
            const selectedIds = this.form.purchaserId ? [this.form.purchaserId] : [];
            this.$refs.orgPicker.show(selectedIds, 'user');
        },

        selectedPurchaser(users) {
            console.log('选择采购员:', users);

            if (users && users.length > 0) {
                const selectedUser = users[0];
                this.form.purchaserId = Number(selectedUser.id);
                this.form.purchaserName = selectedUser.serial + selectedUser.name;
            }
        },

        async submitForm(effectFlag) {
            // 在提交时判断优惠金额是否为负数
            const discountAmount = parseFloat(this.form.discountAmount) || 0;
            if (discountAmount < 0) {
                this.$message.error('输入的采购总金额必须小于等于合计金额+运费');
                return false;
            }

            // 先校验表格数据
            let tableValid = true;
            this.form.items.forEach((item, index) => {
                // 根据采购类型决定校验哪些字段
                const isOfficeSupply = this.baseInfo.purchaseType === 1;
                const isSalesProduct = this.baseInfo.purchaseType === 2 || this.type === 'add';

                if (isSalesProduct) {
                    // 销售商品：校验数量和单价
                    if (!this.validateTableField(index, 'quantity') || !this.validateTableField(index, 'unitPrice')) {
                        tableValid = false;
                    }
                } else if (isOfficeSupply) {
                    // 办公物资：只校验数量，估价不是必填项
                    if (!this.validateTableField(index, 'quantity')) {
                        tableValid = false;
                    }
                }
            });

            // 原有的表单验证逻辑保持不变
            this.$refs.orderForm.validate(async (valid) => {
                if (!valid) {
                    this.$message.error('请填写必填项');
                    return false;
                }

                if (!this.form.items || this.form.items.length === 0) {
                    this.$message.error('请至少添加一个商品');
                    return false;
                }

                try {
                    const submitData = {
                        id: this.form.id || null,
                        supplierId: Number(this.form.supplierId) ? this.form.supplierId : null,
                        salesInvoiceNo: this.form.salesInvoiceNo || '',
                        supplierContactPerson: this.form.supplierContactPerson || '',
                        supplierContactNumber: this.form.supplierContactNumber || '',
                        supplierShippingAddress: this.form.supplierShippingAddress || '',
                        storeName: this.form.storeName || '',
                        shippingAddress: this.form.shippingAddress || '',
                        purchaserId: Number(this.form.purchaserId) || null,
                        freightCost: parseFloat(this.form.freightCost) || 0,
                        discountAmount: parseFloat(this.form.discountAmount) || 0,
                        finalAmount: this.form.finalAmount || 0,
                        attachmentUrl: this.form.attachmentUrl || '',
                        remarks: this.form.remarks || '',
                        items: this.form.items,
                        totalAmount: this.totalAmount,
                        effectFlag: effectFlag // 添加effectFlag参数
                    };

                    console.log('提交数据:', JSON.stringify(submitData, null, 2));

                    let response;
                    if (effectFlag) {
                        // 确认生效，使用srmSurchaseOrderEffect接口
                        response = await this.$api.srmSurchaseOrderEffect(submitData);
                    } else {
                        // 保存操作
                        if (this.type === 'add') {
                            response = await this.$api.srmSurchaseOrderAdd(submitData);
                        } else {
                            response = await this.$api.srmSurchaseOrderEdit(submitData);
                        }
                    }

                    if (response.code === 0) {
                        const successMsg = effectFlag ? '确认生效成功' : '保存成功';
                        this.$message.success(successMsg);
                        this.dialogVisible = false;
                        this.$emit('success');
                    } else {
                        this.$message.error(response.msg || '操作失败');
                    }
                } catch (error) {
                    console.error('提交失败:', error);
                    this.$message.error('提交失败，请稍后重试');
                }
            });
        },

        handleClose() {
            this.$refs.orderForm.clearValidate();
            // 重置文件列表
            this.fileList = [];
            this.logFile = null;

            // 如果是新增状态，重置表单数据
            if (this.type === 'add') {
                this.resetFormData();
            }

            this.$emit('closed');
        },

        removeItem(index) {
            this.form.items.splice(index, 1);
            this.calculateDiscountAmount();
        },

        calculateAmount(index) {
            const item = this.form.items[index];
            const quantity = parseFloat(item.quantity) || 0;
            const unitPrice = parseFloat(item.unitPrice) || 0;
            item.lineAmount = (quantity * unitPrice).toFixed(2);

            this.$set(this.form.items, index, { ...item });
            this.calculateDiscountAmount();
        },

        searchEvent() {
            console.log('点击上传附件');
            // 实现文件上传逻辑
        }
    }
};
</script>

<style scoped lang="scss">
.add_purchase_order {
    /deep/ {
        .el-dialog__title {
            font-weight: 400;
            font-size: 16px;
            color: #333333;
        }

        .el-dialog__body {
            font-size: 13px;
        }
    }
}

.purchase-order {
    margin-top: 20px;

    /deep/.el-form-item__label {
        width: 100px;
        height: 30px;
        line-height: 30px;
    }

    /deep/ .el-table img {
        vertical-align: middle;
    }

    /deep/.el-input,
    /deep/.el-input__inner {
        height: 30px;
        line-height: 28px;
    }

    /deep/ .el-select__caret {
        margin-top: 6px;
    }

    /deep/ .el-input__clear {
        margin-top: -5px;
    }

    /deep/.el-form-item {
        margin-bottom: 15px;
        font-weight: 400;
        font-size: 12px;
        color: #606266;
    }

    // 修改：使用更具体的选择器，避免影响表格内部
    /deep/ .goods-form-item .el-form-item__content {
        margin-left: 30px !important;
        line-height: 40px;
        position: relative;
        font-size: 14px;
    }

    // 表格内表单项目样式 - 高优先级
    /deep/ .el-table {
        .el-form-item {
            margin-bottom: 0;

            .el-form-item__content {
                margin-left: 0 !important;
                line-height: normal;
                display: flex;
                align-items: center;
                justify-content: center;

                .el-input {
                    width: 100%;
                }
            }
        }

        // 表单验证错误样式调整
        .el-form-item.is-error {
            .el-input__inner {
                border-color: #F56C6C;
            }
        }

        // 商品名称单元格样式 - 单行显示，超出省略号
        .goods-name-cell {
            .cell {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                display: block;
                max-width: 100%;
            }
        }

        // 商品名称文本样式
        .goods-name-text {
            display: inline-block;
            max-width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            vertical-align: middle;
        }
    }
}

// 必填标签样式
.required-label {
    &::before {
        content: "*";
        color: #F56C6C;
        margin-right: 4px;
    }
}

.order-form {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
    font-size: 16px;
    color: #333333;
    margin-left: 27px;
    margin-bottom: 10px;

}

// 基础信息只读样式 - 修改为左对齐
.base-info-readonly {
    margin-bottom: 20px;
    border-radius: 4px;

    .info-row {
        margin-bottom: 10px;
        padding-left: 10px;

        &:last-child {
            margin-bottom: 0;
        }
    }

    .info-item {
        display: flex;
        align-items: center;
        min-height: 32px;
        line-height: 32px;
        // margin-left: 32px;

        label {
            color: #606266;
            min-width: auto;
            text-align: left;
            white-space: nowrap;
            flex-shrink: 0;
        }

        span {
            color: #333;
            flex: 1;
            text-align: left;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        // 采购申请单号文本特殊样式
        .application-no-text {
            flex: none;
            max-width: 145px;
            padding-right: 5px;
        }

        // 按钮容器样式
        .el-button {
            z-index: 10;
            position: relative;
        }
    }

    // 确保按钮列有足够空间
    .el-col-2 {
        flex: 0 0 8.333%;
        max-width: 8.333%;
        min-width: 80px; // 确保按钮有足够宽度
    }
}

// 文件列表样式
.file-list {
    .file-item {
        display: flex;
        align-items: center;
        // padding: 8px;
        // border: 1px solid #ebeef5;
        // border-radius: 4px;
        // background-color: #f5f7fa;

        .file-name {
            margin-left: 8px;
            flex: 1;
            margin-top: -4px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
}

// 上传提示样式
.upload-tips {
    font-size: 12px;
    color: #909399;
    margin-top: 5px;
}

/deep/ .el-upload-dragger {
    border: none;
    width: 80px;
    height: 40px;
}

/* 供应商下拉框样式 - 固定高度 */
/deep/ .supplier-select {
    .el-select-dropdown__list {
        max-height: 300px !important;
        overflow-y: auto;
    }

    .el-select-dropdown__wrap {
        max-height: 300px !important;
    }
}
</style>